import React from 'react';

const FormattedText: React.FC<React.PropsWithChildren> = (props) => {
  return <div className="formatted-text">{props.children}</div>;
};

export default FormattedText;
